import React from 'react';

import { Wrapper } from './NotFoundPage.s';

export const NotFoundPage = () => (
  <Wrapper>This page doesn't exist or you don't have access to see this content</Wrapper>
);
